import * as React from "react";
import { Link } from "gatsby";
import {
  footer,
  footerNav,
  linkArea,
  linkCategory,
  listHeader,
  linkList,
  link,
  navLink,
  copyright,
} from "./footer.module.css";

const Footer = () => {
  return (
    <footer className={footer}>
      <nav className={footerNav}>
        <div>
          <Link to="/">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="243"
              height="50"
              fill="none"
            >
              <desc>BeaSkyBlue</desc>
              <path
                d="M28.125 12.5c0-4.627 2.514-8.666 6.25-10.828C32.536.609 30.402 0 28.125 0c-6.904 0-12.5 5.596-12.5 12.5 0 1.271.19 2.499.543 3.655-1.557 1.555-2.706 3.517-3.272 5.714l-.395.006c-4.627 0-8.666-2.514-10.828-6.25C.609 17.464 0 19.598 0 21.875c0 6.904 5.596 12.5 12.5 12.5 1.271 0 2.499-.19 3.655-.543 1.555 1.557 3.517 2.706 5.714 3.272l.006.395c0 4.627-2.514 8.666-6.25 10.828A12.44 12.44 0 0 0 21.875 50c6.904 0 12.5-5.596 12.5-12.5 0-1.272-.19-2.499-.543-3.655 1.557-1.554 2.706-3.517 3.272-5.714.131-.004.263-.006.395-.006 4.627 0 8.666 2.514 10.828 6.25A12.44 12.44 0 0 0 50 28.125c0-6.904-5.596-12.5-12.5-12.5-1.272 0-2.499.19-3.655.543-1.554-1.557-3.517-2.706-5.714-3.272l-.006-.395z"
                fill="#f4bc46"
              />
              <path
                d="M59.016 37V11.406h8.367c2.777 0 4.863.574 6.258 1.723 1.406 1.148 2.109 2.848 2.109 5.098 0 1.195-.34 2.256-1.019 3.182-.68.914-1.606 1.623-2.777 2.127 1.383.387 2.473 1.125 3.27 2.215.808 1.078 1.213 2.367 1.213 3.867 0 2.297-.744 4.102-2.232 5.414S70.611 37 67.893 37h-8.877zm3.375-11.971v9.211h5.572c1.57 0 2.807-.404 3.709-1.213.914-.82 1.371-1.945 1.371-3.375 0-3.082-1.676-4.623-5.027-4.623h-5.625zm0-2.707h5.098c1.477 0 2.654-.369 3.533-1.107.891-.738 1.336-1.74 1.336-3.006 0-1.406-.41-2.426-1.23-3.059-.82-.644-2.068-.967-3.744-.967h-4.992v8.139zm26.438 15.029c-2.578 0-4.676-.844-6.293-2.531-1.617-1.699-2.426-3.967-2.426-6.803v-.598c0-1.887.357-3.568 1.072-5.045.727-1.488 1.734-2.648 3.023-3.48 1.301-.844 2.707-1.266 4.219-1.266 2.473 0 4.395.814 5.766 2.443s2.057 3.961 2.057 6.996v1.354H83.361c.047 1.875.592 3.393 1.635 4.553 1.055 1.148 2.391 1.723 4.008 1.723 1.148 0 2.121-.234 2.918-.703s1.494-1.09 2.092-1.863L96 33.678c-1.594 2.449-3.984 3.674-7.172 3.674zm-.404-17.051c-1.312 0-2.414.48-3.305 1.441-.891.949-1.441 2.285-1.652 4.008h9.527v-.246c-.094-1.652-.539-2.93-1.336-3.832-.797-.914-1.875-1.371-3.234-1.371zM111.768 37c-.188-.375-.34-1.043-.457-2.004-1.512 1.57-3.317 2.355-5.415 2.355-1.875 0-3.416-.527-4.623-1.582a5.18 5.18 0 0 1-1.792-4.043c0-1.981.749-3.516 2.249-4.606 1.512-1.102 3.633-1.652 6.364-1.652h3.164v-1.494c0-1.137-.34-2.039-1.02-2.707-.679-.68-1.681-1.02-3.006-1.02-1.16 0-2.132.293-2.918.879s-1.177 1.295-1.177 2.127h-3.27c0-.949.334-1.863 1.002-2.742.68-.891 1.594-1.594 2.742-2.109 1.16-.516 2.432-.773 3.815-.773 2.191 0 3.908.551 5.15 1.652 1.242 1.09 1.887 2.596 1.934 4.518v8.754c0 1.746.222 3.135.668 4.166V37h-3.41zm-5.397-2.478c1.02 0 1.986-.264 2.9-.791s1.577-1.213 1.987-2.057v-3.902h-2.549c-3.984 0-5.977 1.166-5.977 3.498 0 1.02.34 1.816 1.02 2.391s1.553.861 2.619.861zm21.287-8.93c-2.894-.832-5.004-1.852-6.328-3.059-1.312-1.219-1.969-2.719-1.969-4.5 0-2.016.803-3.68 2.409-4.992 1.617-1.324 3.714-1.986 6.292-1.986 1.758 0 3.323.34 4.694 1.019 1.383.68 2.449 1.617 3.199 2.813a7.15 7.15 0 0 1 1.143 3.92h-3.393c0-1.547-.492-2.76-1.476-3.639-.985-.891-2.374-1.336-4.167-1.336-1.664 0-2.964.369-3.902 1.108-.926.726-1.389 1.74-1.389 3.041 0 1.043.44 1.928 1.319 2.654.89.715 2.396 1.371 4.517 1.969 2.133.598 3.797 1.26 4.993 1.986 1.207.715 2.097 1.553 2.671 2.514.586.961.879 2.092.879 3.393 0 2.074-.808 3.738-2.425 4.992-1.618 1.242-3.78 1.863-6.487 1.863-1.758 0-3.398-.334-4.922-1.002-1.523-.68-2.701-1.605-3.533-2.777-.82-1.172-1.23-2.502-1.23-3.99h3.392c0 1.547.569 2.771 1.705 3.674 1.149.891 2.678 1.336 4.588 1.336 1.782 0 3.147-.363 4.096-1.09s1.424-1.717 1.424-2.971-.44-2.221-1.319-2.9c-.878-.691-2.472-1.371-4.781-2.039zm18.633 2.602l-2.039 2.127V37H141V10h3.252v16.33l1.74-2.092 5.924-6.258h3.955l-7.4 7.945L156.732 37h-3.814l-6.627-8.807zm19.16 4.043l4.43-14.256h3.48l-7.646 21.955c-1.184 3.164-3.065 4.746-5.643 4.746l-.615-.053-1.213-.229v-2.637l.879.07c1.102 0 1.957-.223 2.566-.668.622-.445 1.131-1.26 1.53-2.443l.72-1.934-6.785-18.809h3.551l4.746 14.256zM176.789 37V11.406h8.367c2.778 0 4.864.574 6.258 1.723 1.406 1.148 2.109 2.848 2.109 5.098 0 1.195-.339 2.256-1.019 3.182-.68.914-1.606 1.623-2.777 2.127 1.382.387 2.472 1.125 3.269 2.215.809 1.078 1.213 2.367 1.213 3.867 0 2.297-.744 4.102-2.232 5.414S188.385 37 185.666 37h-8.877zm3.375-11.971v9.211h5.572c1.571 0 2.807-.404 3.709-1.213.914-.82 1.371-1.945 1.371-3.375 0-3.082-1.675-4.623-5.027-4.623h-5.625zm0-2.707h5.098c1.476 0 2.654-.369 3.533-1.107.891-.738 1.336-1.74 1.336-3.006 0-1.406-.41-2.426-1.231-3.059-.82-.644-2.068-.967-3.744-.967h-4.992v8.139zM202.242 37h-3.252V10h3.252v27zm16.963-1.881c-1.266 1.488-3.123 2.232-5.572 2.232-2.028 0-3.574-.586-4.641-1.758-1.054-1.184-1.588-2.93-1.599-5.238V17.981h3.252v12.287c0 2.883 1.171 4.324 3.515 4.324 2.485 0 4.137-.926 4.957-2.777V17.981h3.252V37h-3.094l-.07-1.881zm16.014 2.232c-2.578 0-4.676-.844-6.293-2.531-1.617-1.699-2.426-3.967-2.426-6.803v-.598c0-1.887.357-3.568 1.072-5.045.727-1.488 1.735-2.648 3.024-3.48 1.3-.844 2.707-1.266 4.218-1.266 2.473 0 4.395.814 5.766 2.443s2.057 3.961 2.057 6.996v1.354h-12.885c.047 1.875.592 3.393 1.635 4.553 1.054 1.148 2.39 1.723 4.008 1.723 1.148 0 2.121-.234 2.917-.703s1.495-1.09 2.092-1.863l1.987 1.547c-1.594 2.449-3.985 3.674-7.172 3.674zm-.405-17.051a4.32 4.32 0 0 0-3.304 1.441c-.891.949-1.442 2.285-1.653 4.008h9.528v-.246c-.094-1.652-.539-2.93-1.336-3.832-.797-.914-1.875-1.371-3.235-1.371z"
                fill="#2f4f4f"
              />
            </svg>
          </Link>
          <p className={copyright}>
            <small>Copyright &copy; 2021 iruda</small>
          </p>
        </div>
        <div className={linkArea}>
          <div className={linkCategory}>
            <h4 className={listHeader}>Learn</h4>
            <ul className={linkList}>
              <li className={link}>
                <Link to="/html/" className={navLink}>
                  HTML
                </Link>
              </li>
              {/* <li className={link}>
                <Link to="/wait/" className={navLink}>
                  CSS
                </Link>
              </li> */}
              <li className={link}>
                <Link to="/js/" className={navLink}>
                  JS
                </Link>
              </li>
              <li className={link}>
                <Link to="/python/" className={navLink}>
                  Python
                </Link>
              </li>
              {/* <li className={link}>
                <Link to="/wait/" className={navLink}>
                  SQL
                </Link>
              </li>
              <li className={link}>
                <Link to="/wait/" className={navLink}>
                  Shell
                </Link>
              </li>
              <li className={link}>
                <Link to="/wait/" className={navLink}>
                  Office
                </Link>
              </li>
              <li className={link}>
                <Link to="/wait/" className={navLink}>
                  Cloud
                </Link>
              </li> */}
              <li className={link}>
                <Link to="/more/" className={navLink}>
                  More
                </Link>
              </li>
            </ul>
          </div>
          <div className={linkCategory}>
            <h4 className={listHeader}>Follow</h4>
            <ul className={linkList}>
              <li className={link}>
                <a href="https://github.com/iruda" className={navLink}>
                  GitHub
                </a>
              </li>
              <li className={link}>
                <a href="https://twitter.com/yukihirarinta" className={navLink}>
                  Twitter
                </a>
              </li>
              <li className={link}>
                <a
                  href="https://www.youtube.com/channel/UCp1ZTB8UNQpLw0YCTwNH7Ig"
                  className={navLink}
                >
                  Youtube
                </a>
              </li>
              <li className={link}>
                <a
                  href="https://www.twitch.tv/yukihirarinta"
                  className={navLink}
                >
                  Twitch
                </a>
              </li>
              <li className={link}>
                <a href="https://beaskyblue.com/rss.xml" className={navLink}>
                  RSS
                </a>
              </li>
            </ul>
          </div>
          <div className={linkCategory}>
            <h4 className={listHeader}>More</h4>
            <ul className={linkList}>
              <li className={link}>
                <Link to="/about/" className={navLink}>
                  About
                </Link>
              </li>
              <li className={link}>
                <Link to="/" className={navLink}>
                  Blog
                </Link>
              </li>
              <li className={link}>
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSdPpWaVttNbNGSdm8C7Gyyhn8Mmecl0Rc7zg2Yv1HFNSp5NOw/viewform?usp=sf_link"
                  className={navLink}
                >
                  Contact
                </a>
              </li>
              <li className={link}>
                <Link to="/privacy/" className={navLink}>
                  Privacy
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </footer>
  );
};

export default Footer;
